import React from 'react';
import { useQuery, useMutation } from '@apollo/client';
import { View, Text, Pressable } from 'react-native';
import DataTable from '@preflighttech/preflight-tables';
import moment from 'moment';

import DataState from 'app/src/components/DataState';
import { PageTitle, CardContainer, Card } from 'app/src/elements';
import minimalTable from 'app/src/elements/minimalTable';
import { Link } from 'app/src/utils/routing';

import { ASSIGNMENT_NOTIFICATIONS, RESOLVE_NOTIFICATION } from './queries';

const Assignments = ({ data, refetch }) => {
  if (!data) {
    const assignment = useQuery(ASSIGNMENT_NOTIFICATIONS);
    data = assignment?.data;
    refetch = assignment?.refetch;
  }

  const [resolveNotification] = useMutation(RESOLVE_NOTIFICATION, {
    onCompleted: refetch
  });

  const handleReady = asset => {
    const confirmation =
      `Really mark ${asset.name} as ready and resolve notifcation?`;

    if (confirm(confirmation)) {
      resolveNotification({ variables: { id: asset.id }});
    }
  }

  const columns = [
    {
      key: 'body',
      label: 'Notification',
      sort: 'prevent',
    },
    {
      key: 'seller',
      label: 'Seller',
      sort: 'prevent',
      value: ({ value }) => value?.name,
      content: ({ entry, value }) => (
        <>
          {value ? (
            <>
              <Link to={`/sellers/${entry.seller.id}`}>
                <Text>{value}</Text>
              </Link>
              <Text>{moment(entry.createdAt).format('MM-DD-YY \@ hh:mmA')}</Text>
            </>
          ) : (
            null
          )}
        </>
      )
    },
    {
      key: 'actions',
      label: 'Actions',
      sort: 'prevent',
      content: ({ entry }) => (
        <View style={{flexDirection: 'row'}}>
          <Link to={entry.resourcePath}>View Asset</Link>
          <Text>{' | '}</Text>
          <Pressable onPress={() => handleReady(entry)}>
            <Text>Mark as Ready</Text>
          </Pressable>
        </View>
      )
    },
  ];

  return  (
    <>
      <PageTitle>
        Assignment by Seller
        {data?.notifications && ` (${data.notifications.length})`}
      </PageTitle>
      {!data ? (
        <DataState.Loading />
      ) : (
        <CardContainer>
          <Card style={{padding: 0, paddingBottom: 3}}>
            <DataTable.Simple
              data={data.notifications}
              columns={columns}
              component={minimalTable}
              pageLength="All"
            />
          </Card>
        </CardContainer>
      )}
    </>
  );
};

export default Assignments;
